import {} from "./Net.js";
import { clonePortRecord } from "./clonePortRecord.js";
export function cloneNodeEntry(entry) {
    return Object.assign(Object.assign({}, entry), { ports: clonePortRecord(entry.ports) });
}
//# sourceMappingURL=cloneNodeEntry.js.map